import store from "@/store";

export default {
    methods: {
        unselectFilter(type, id) {
            let filter = this.filtersData;
            let models = this.$store.state.lib.new_cars_models;
            const max_filters = store.state.oldCarsStartParams || store.state.oldCars.startParams;
            const max_filters_new_cars = store.state.newCars.startParams;
            const startPrice = this.$store.state.dealers.page.price_f;
            const newCarsSliderFilters = ['affinity', 'towing_capacity', 'engine', 'co2', 'battery_capacity', 'horse_power']

            if (type == "verdtilbod" || type == "parking" || type == 'notInCountry') {
                filter[type] = id;
            } else if (type == 'discount') {
                filter[type] = !id;
            } else if (type === 'brands') {
                models.filter((e) => {
                    if (e.brand_id == id && filter.models_id && filter.models_id.indexOf(e.model_id) >= 0) {
                        let index = filter.models_id.indexOf(e.model_id);
                        filter.models_id.splice(index, 1);
                    }


                    /*if (e.brand_id == id && filter.brands_model && filter.brands_model.indexOf(e.model_class) >= 0) {
                        let index = filter.brands_model.indexOf(e.model_class);

                        console.log("INDEX",index)
                        filter.brands_model.splice(index, 1);
                    }*/
                });
                filter[type].splice(filter[type].indexOf(id), 1);
            } else if (['category', 'year'].includes(type)) {
                let index = filter[type].indexOf(id);
                filter[type].splice(index, 1);
            } else if (["argerd", "ekinn", "verd", "affinity", "tire_size", "rim_size", "cylinders", ...newCarsSliderFilters].includes(type)) {
                filter[type] = [];

                if(['CarsInStock', 'DealersCars'].includes(this.$route.name) && newCarsSliderFilters.includes(type)){
                    filter[type] = [max_filters_new_cars[type].min, max_filters_new_cars[type].max];
                }else if (['CarsInStock', 'DealersCars'].includes(this.$route.name)) {
                    filter[type] = [startPrice.mi, startPrice.ma];
                }else if (['OldCars','k7Cars'].includes(this.$route.name)) {
                    if(['affinity', 'argerd', 'verd', 'ekinn', 'towing_capacity', "tire_size", "rim_size", "cylinders"].includes(type)){
                        filter[type] = [max_filters[type].min, max_filters[type].max];
                    }else{
                        filter[type] = [max_filters[type].mi, max_filters[type].ma];
                    }
                } else {
                    filter[type] = [max_filters[type].mi, max_filters[type].ma];
                }
            } else {
                filter[type].splice(filter[type].indexOf(id), 1);
            }
        },
        checkBrandsModels() {
            let filter = this.filters;
            let models = this.$store.state.lib.new_cars_models;
            let m = [];

            filter.brands.map(id => {
                models.filter((e) => e.brand_id == id && filter.models_id.includes(e.model_id)).map(e => m.push(e.model_id));
            })

            if (!this.compare(m, filter.models_id)) {
                filter.models_id = m;
            }
            /*
            filter.brands.map(id => {
                models.filter((e) => e.brand_id == id && filter.brands_model.includes(e.model_class)).map(e => m.push(e.model_class));
            })

            if (!this.compare(m, filter.brands_model)) {
                filter.brands_model = m;
            }*/

        },
        diff(a1, a2) {
            return a1.filter(i => !a2.includes(i))
                .concat(a2.filter(i => !a1.includes(i)))
        },
        compare(a1, a2) {
            return a1.length == a2.length && a1.every((v, i) => v === a2[i])
        }
    }
}
